class Test {
	main = () => {
		console.log('Forester Music');
	};
}
const test = new Test();
test.main();
